<template>
  <div class="group-edit-container">
    <div class="close-button">
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="closeGroupEdit()"
      ></feather-icon>
    </div>
    <div class="group-name-label">グループ名</div>
    <div class="group-name-input">
      <input type="text" v-model="editGroupName" placeholder="グループ名を登録してください。" maxlength = "30">
    </div>
    <div class="group-color-label">カラー</div>
    <div class="group-color-pallete">
      <div class="color-pallete-line">
        <!-- 10個ずつ均等に並べる、10個に満たない場合は透明なcolorChipを置いてスペースを調整 -->
        <color-chip v-for="(color, index) in colorOptions.slice(0, 10)" :key="index"
          :color="color" class="color-chip"
          :focused="selectedColor == color"
          @click.native="selectedColor = color"
        ></color-chip>
        <color-chip v-for="i of 10 - colorOptions.slice(0, 10).length" :key="i - 10"
          color="#00000000" class="empty-color-chip"
        ></color-chip>
      </div>
      <div class="color-pallete-line">
        <color-chip v-for="(color, index) in colorOptions.slice(10, 20)" :key="index"
          :color="color" class="color-chip"
          :focused="selectedColor == color"
          @click.native="selectedColor = color"
        ></color-chip>
        <color-chip v-for="i of 10 - colorOptions.slice(10, 20).length" :key="i - 10"
          color="#00000000" class="empty-color-chip"
        ></color-chip>
      </div>
    </div>
    <div class="control-spacer"></div>
    <div class="button-area" :class="{'add-layout': mode == 'add'}">
      <button class="save-button" :class="{'button-disabled': editGroupName.length == 0}" @click="clickSaveButton">保存</button>
      <button class="delete-button" v-if="mode == 'edit'" @click="clickDeleteButton">削除</button>
    </div>

    <group-delete-popup class="no-select-popup" :popupActive.sync="deletePopupActive" @clickDeleteButton="executeDelete">
    </group-delete-popup>
  </div>
</template>

<script>
import GroupDeletePopup from "./GroupDeletePopup.vue";
import ColorChip from "./ColorChip";
import { GROUP_COLOR_PALETTE } from "@/config/const.js"

export default {
  components: {
    ColorChip,
    GroupDeletePopup
  },
  props: {
    isShow: Boolean,
    mode: String, // edit or add
    documentId: String,
    initialGroupName: String,
    initialColor: String,
  },
  data() {
    return {

      editGroupName: this.initialGroupName ? this.initialGroupName : "",

      deletePopupActive: false,

      selectedColor: this.initialColor ? this.initialColor : GROUP_COLOR_PALETTE[0].normal,
      colorOptions: GROUP_COLOR_PALETTE.map(element => element.normal)
    };
  },
  watch: {
    isShow(value) {
      if (this.mode == "edit" && value == true) {
        this.editGroupName = this.initialGroupName
        this.selectedColor = this.initialColor
      }
    }
  },
  methods: {
    clickSaveButton() {
      this.$emit("clickSaveButton", {
        color: this.selectedColor,
        label: this.editGroupName,
        documentId: this.mode == "edit" ? this.documentId : null
      })
      this.editGroupName = ""
      this.selectedColor = this.initialColor ? this.initialColor : GROUP_COLOR_PALETTE[0].normal
    },
    clickDeleteButton() {
      this.deletePopupActive = true
    },
    executeDelete() {
      this.$emit("clickDeleteButton", {
        documentId: this.documentId
      })
      this.deletePopupActive = false
    },
    closeGroupEdit() {
      this.$emit("closeGroupEdit")
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
.group-edit-container {
  position: relative;
  height: 370px;
  color: white;
  background: #3d4656;
  border-radius: 8px;
  padding: 16px 22px;
  margin: 8px 14px;
  font-size: 17px;
  .close-button{
    position: absolute;
    width: 23px;
    height: 23px;
    right: 20px;
  }
  .group-name-label {
    margin-top: 10px;
    font-size: 15px;
  }
  .group-name-input {
    position: relative;
    margin-top: 10px;
    margin-bottom: 30px;
    input {
      color: white;
      font-size: 15px;
      box-sizing: border-box;
      width: 100%;
      margin: 8px 0;
      padding: 0.5em;
      padding-left: 10px;
      transition: 0.3s;
      background: #3D4656;
      border: 1px solid #C4C4C4;
      border-radius: 6px;
      outline: none;
      &::placeholder {
        color: #A0A3A7;
      }
      &:focus {
        box-sizing: border-box;
        border: 1px solid #2D9CDB;
      }
    }
  }
  .group-color-label {
    font-size: 15px;
  }
  .group-color-pallete {
    margin-top: 20px;
    margin-bottom: 20px;
    .color-pallete-line {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .color-chip {
      cursor: pointer;
    }
  }
  .control-spacer {
    height: 1px;
    margin-top: 30px;
    margin-bottom: 30px;
    background: #C4C4C4;
  }
  .button-area {
    display: flex;
    justify-content: space-between;
    &.add-layout {
      justify-content: center !important;
    }
    button {
      appearance: none;
      color: white;
      width: 156px;
      height: 33px;
      display: flex;
      border-radius: 6px;
      justify-content: center;
      align-items: center;
      background: #3d4656;
      transition: 0.3s;
      cursor: pointer;
    }
    .save-button{
      border: solid 1px #2D9CDB;
      &:hover {
        background: rgba(45, 156, 219, 0.4);
      }
      &.button-disabled {
        pointer-events:none;
        background: #677182 !important;
      }
    }
    .delete-button {
      border: solid 1px #EB5757;
      &:hover {
        background: rgba(235, 87, 87, 0.4);
      }
    }
  }
}

</style>
